import { Box, Grid, Skeleton, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { ProductCardSkeleton } from "./product/ProductCardSkeleton"

const SKELETON_GROUPS: readonly number[] = [4, 3]

const useStyles = makeStyles()((theme) => ({
    container: {
        display: "grid",
        maxHeight: "100%",
        gridTemplateRows: "auto 1fr",
        overflow: "hidden",
        width: "100%",
    },
    header: {
        padding: "1.25rem 1rem 1.5rem",
        background: theme.palette.common.white,
        flexShrink: 0,
    },
    headerLeft: {
        display: "flex",
        alignItems: "center",
        gap: ".5rem",
    },
    deliveryChip: {
        transform: "none",
        borderRadius: "6.25rem",
    },
    addButton: {
        transform: "none",
        borderRadius: "6.25rem",
    },
    headerRight: {
        display: "flex",
        alignItems: "center",
        gap: ".75rem",
        flexShrink: 0,
    },
    iconButton: {
        transform: "none",
        borderRadius: ".5rem",
    },
    content: {
        padding: "1.5rem",
        [theme.breakpoints.down("sm")]: {
            padding: "1rem",
        },
        background: theme.palette.tailwind.slate[100],
        overflowY: "auto",
    },
    groupTitle: {
        transform: "none",
        borderRadius: ".375rem",
    },
}))

export function ShopListSkeleton() {
    const { classes } = useStyles()

    return (
        <Box className={classes.container}>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                flexWrap={{ xs: "wrap", sm: "nowrap" }}
                gap=".75rem"
                className={classes.header}
            >
                <Box className={classes.headerLeft}>
                    <Skeleton variant="rounded" animation="wave" width="8rem" height="2rem" className={classes.deliveryChip} />
                    <Skeleton variant="rounded" animation="wave" width="5rem" height="2rem" className={classes.addButton} />
                </Box>
                <Box className={classes.headerRight}>
                    <Skeleton variant="rounded" animation="wave" width="2rem" height="2rem" className={classes.iconButton} />
                    <Skeleton variant="rounded" animation="wave" width="2rem" height="2rem" className={classes.iconButton} />
                    <Skeleton variant="rounded" animation="wave" width="2rem" height="2rem" className={classes.iconButton} />
                    <Skeleton variant="rounded" animation="wave" width="2rem" height="2rem" className={classes.iconButton} />
                </Box>
            </Stack>
            <Stack gap="2rem" className={classes.content}>
                {SKELETON_GROUPS.map((count, groupIndex) => (
                    <Stack gap="1.5rem" key={groupIndex}>
                        <Skeleton
                            variant="rounded"
                            animation="wave"
                            width="10rem"
                            height="1.5rem"
                            className={classes.groupTitle}
                        />
                        <Grid container gap={{ xs: ".75rem", sm: "1.5rem" }} alignItems="stretch">
                            {Array.from({ length: count }).map((_, cardIndex) => (
                                <ProductCardSkeleton key={cardIndex} />
                            ))}
                        </Grid>
                    </Stack>
                ))}
            </Stack>
        </Box>
    )
}
